export const apps = new Map([
  ['mg-mczx', {
    appId: '20c388c5b45e316d42605e09ddd37437',
    schannel: '014X031',
    projectId: 'AI_HR_MCZX',
  }],
])
